/**
 * Função genérica para corrigir URLs de imagens do Directus
 * @param url - URL ou ID da imagem
 * @returns URL completa da imagem
 */
export const fixDirectusImageUrl = (url: string): string => {
  // Se é um ID de imagem do Directus (UUID)
  if (url.match(/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/)) {
    // Fonte da verdade agora é sempre a pasta public/uploads do frontend
    // Não dependemos mais do Directus para servir imagens
    return `/uploads/${url}.png`;
  }

  // Se é uma URL HTTP, converte para HTTPS em produção
  if (import.meta.env.PROD && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }

  return url;
};

/**
 * Função para verificar se uma string é um UUID válido
 * @param str - String para verificar
 * @returns true se for um UUID válido
 */
export const isUUID = (str: string): boolean => {
  return /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(str);
};

